import React, { useState } from 'react';

const TOSModal = ({ onAgree }) => {
  const [email, setEmail] = useState('');

  const handleSubmit = () => {
    onAgree(email);
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h2 style={styles.heading}>Terms of Service</h2>
        <div style={styles.scrollBox}>
          <p><strong>1. No Expectation of Profit</strong><br />
          Participation in DeepMeme does <strong>not</strong> constitute an investment. You should have <strong>no expectation of profit</strong>. DeepMeme is a competitive, experimental memecoin launchpad and entertainment platform.</p>

          <p><strong>2. Not an Investment Platform</strong><br />
          DeepMeme is not a facilitator of investment opportunities. It is a <strong>trustless game environment</strong> operating through decentralized smart contracts and public Solana wallets. No financial advice or investment services are offered.</p>

          <p><strong>3. Not a Money Transmitter</strong><br />
          DeepMeme does <strong>not</strong> transmit funds between users or act as a custodian. All SOL contributions are deposited into a public smart vault during the round and are automatically handled by contract logic. DeepMeme never touches or routes your funds manually.</p>

          <p><strong>4. Platform Fee</strong><br />
          DeepMeme takes a <strong>1% platform fee</strong> from each round’s total contributions. This is used to maintain the platform and is deducted before rewards are distributed.</p>

          <p><strong>5. No Guarantees or Control</strong><br />
          DeepMeme makes <strong>no guarantees</strong> about the success, stability, or functionality of tokens, rounds, or outcomes. The system is autonomous and operates as-is, with no warranties expressed or implied.</p>

          <p><strong>6. No Access to Wallets</strong><br />
          DeepMeme does <strong>not</strong> have access to your wallet or private keys. It cannot recover, move, or refund any assets on your behalf. You are solely responsible for your wallet and actions on-chain.</p>

          <p><strong>7. Early Round Termination</strong><br />
          If a round ends early (before its scheduled time), <strong>all contributions will be refunded</strong> and <strong>no tokens will be minted</strong>. This ensures fairness if unexpected issues arise.</p>

          <p><strong>8. Content Moderation</strong><br />
          Tokens may be deleted at any time if they violate DeepMeme’s launchpad rules, including but not limited to:<br />
          - Illegal images<br />
          - Inappropriate or explicit content<br />
          - Links to scams, malware, or illegal activities<br />
          Moderation decisions are final.</p>

          <p><strong>9. Token Distribution Mechanics</strong><br />
          Only <strong>one</strong> token is minted per round: the one with the highest SOL support. All other token candidates are deleted. You agree that:<br />
          - You may <strong>not receive the token</strong> you contributed to.<br />
          - Instead, you will receive a <strong>pro-rata share of the winning token</strong>, based on your contribution amount.<br />
          This is the core mechanic of the DeepMeme game.</p>

          <p><strong>10. No Refunds After Settlement</strong><br />
          Once a round has ended and a token is deployed, <strong>no refunds are possible</strong>, even if the token performs poorly or is deleted from DEXs.</p>

          <p><strong>11. Eligibility</strong><br />
          You confirm that you are legally allowed to interact with blockchain-based applications and that you take full responsibility for compliance with your local laws.</p>

          <p><strong>12. Modifications</strong><br />
          DeepMeme may update or change these terms at any time. Continued use of the platform indicates your acceptance of the most current version.</p>
        </div>

        <input
          type="email"
          placeholder="Optional Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={styles.input}
        />
        <button onClick={handleSubmit} style={styles.button}>
          Agree and Continue
        </button>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modal: {
    backgroundColor: '#1e1e1e',
    padding: '2rem',
    borderRadius: '12px',
    width: '90%',
    maxWidth: '400px',
    color: '#fff',
    fontFamily: 'inherit',
    boxShadow: '0 0 20px rgba(0, 255, 255, 0.3)',
  },
  heading: {
    marginBottom: '1rem',
    fontSize: '1.5rem',
    color: '#FAFF00',
    fontFamily: 'VT323',
  },
  scrollBox: {
    maxHeight: '250px',
    overflowY: 'scroll',
    marginBottom: '1rem',
    padding: '1rem',
    backgroundColor: '#111',
    border: '1px solid #333',
    borderRadius: '6px',
    fontSize: '0.85rem',
    lineHeight: '1.5',
  },
  input: {
    width: '100%',
    padding: '0.5rem',
    marginBottom: '1rem',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontFamily: 'inherit',
  },
  button: {
    backgroundColor: '#6e2fbd',
    color: '#00FFFF',
    border: '2px solid #00FFFF',
    padding: '0.5rem 1rem',
    borderRadius: '6px',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '1rem',
    width: '100%',
  },
};

export default TOSModal;
